// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1BWZA","hint":"styles_hint__26-8c","addHint":"styles_addHint__CPJow","buttons":"styles_buttons__25nwi"};